import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const X = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="x icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      d="M19.2426 22.0531C20.0237 22.8341 21.29 22.8341 22.0711 22.0531C22.8521 21.272 22.8521 20.0057 22.0711 19.2246L14.8284 11.982L22.0711 4.73935C22.8521 3.9583 22.8521 2.69197 22.0711 1.91092C21.29 1.12987 20.0237 1.12987 19.2426 1.91092L12 9.15356L4.75735 1.91092C3.9763 1.12987 2.70997 1.12987 1.92893 1.91092C1.14788 2.69197 1.14788 3.9583 1.92893 4.73935L9.17157 11.982L1.92893 19.2246C1.14788 20.0057 1.14788 21.272 1.92893 22.0531C2.70997 22.8341 3.9763 22.8341 4.75735 22.0531L12 14.8104L19.2426 22.0531Z"
    />
  </svg>
)
